import { userChatsQuery } from 'app/features/chats/queries'
import { ChatsScreen } from 'app/features/chats/screens'
import { GroupNavCarousel } from 'app/features/group/components'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page() {
  return <ChatsScreen HeaderComponent={<GroupNavCarousel />} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user
  const client = initializeApollo({ token: user?.token })

  if (user) {
    await client.query({
      query: userChatsQuery.query,
      variables: {
        ...userChatsQuery.defaultVariables,
      },
    })
  }

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
